import { render } from "./add-content.vue?vue&type=template&id=2c5c0abe"
import script from "./add-content.vue?vue&type=script&lang=js"
export * from "./add-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__